import { render, staticRenderFns } from "./money_transfers.vue?vue&type=template&id=7ceb1894&"
import script from "./money_transfers.vue?vue&type=script&lang=js&"
export * from "./money_transfers.vue?vue&type=script&lang=js&"
import style0 from "./money_transfers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports